import React from "react";
import { useNavigate } from "react-router-dom";
import "./CategoryList.css";

const CategoryList = ({ categories }) => {
  const navigate = useNavigate();

  const getCategoryEmoji = (name) => {
    const category = name.toLowerCase();

    if (category.includes("pizza")) return "🍕";
    if (category.includes("burger")) return "🍔";
    if (category.includes("drink")) return "🥤";
    if (category.includes("coffee")) return "☕";
    if (category.includes("dessert")) return "🍰";
    if (category.includes("cake")) return "🎂";
    if (category.includes("ice")) return "🍨";
    if (category.includes("chicken")) return "🍗";
    if (category.includes("biryani")) return "🍛";
    if (category.includes("rice")) return "🍚";
    if (category.includes("noodle")) return "🍜";
    if (category.includes("pasta")) return "🍝";
    if (category.includes("sandwich")) return "🥪";
    if (category.includes("salad")) return "🥗";
    if (category.includes("breakfast")) return "🍳";
    if (category.includes("veg")) return "🥦";
    if (category.includes("fries")) return "🍟";

    return "🍽️";
  };

  return (
    <div className="categories-section">
      <div className="section-header">
        <div>
          <h3 className="section-title">📖 Categories</h3>
          <p className="section-subtitle">Explore food collections</p>
        </div>

        <button className="see-all-btn" onClick={() => navigate("/category")}>
          See All →
        </button>
      </div>

      <div className="categories-scroll">
        {categories.slice(0, 8).map((cat) => (
          <div
            className="category-item"
            key={cat.id}
            onClick={() => navigate(`/category?id=${cat.id}`)}>
            <div className="category-circle">
              {cat.image ? (
                <img
                  src={`http://127.0.0.1:8000/${cat.image}`}
                  alt={cat.category_name}
                />
              ) : (
                <span>{getCategoryEmoji(cat.category_name)}</span>
              )}
            </div>

            <p>{cat.category_name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryList;
